import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //所有打开的路由
    openTab:[],
    //激活状态
    activeIndex:'/main', 

  },
  mutations: {
    // 添加tabs
    add_tabs (state, data) {
      if (this.state.openTab.indexOf(data) === -1){
        this.state.openTab.push(data);
      }
    },
    // 删除tabs
    delete_tabs (state, route) {
      let index = 0;
      for (let option of state.openTab) {
        if (option.route === route) {
          break;
        }
        index++;
      }
      this.state.openTab.splice(index, 1);
    },
    // 设置当前激活的tab
    set_active_index (state, index) {
      this.state.activeIndex = index;
    },

    // 刷新opentab
    ref_opentab(state){
      this.state.openTab = []
    },

  },
  getters : {
    
    },
  actions: {

  }
})
